import * as am5 from "@amcharts/amcharts5";
import * as am5map from "@amcharts/amcharts5/map";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import am5geodata_worldLow from "@amcharts/amcharts5-geodata/worldLow";

export default {
    init() {
        this. trMap();
        this.trContactForm();
    },
    trMap(){
        var root = am5.Root.new("tr-map");

        // Set themes
        root.setThemes([
            am5themes_Animated.new(root)
        ]);

        var chart = root.container.children.push(am5map.MapChart.new(root, {
            homeZoomLevel: 4,
            homeGeoPoint: {longitude: 10, latitude: 56}
        }));

        var polygonSeries = chart.series.push(am5map.MapPolygonSeries.new(root, {
            geoJSON: am5geodata_worldLow,
            exclude: ["AQ"],
            fill: am5.color(0xD8DEE6),
            stroke: am5.color(0x565655),
        }));

        polygonSeries.events.on("datavalidated", () => {
            chart.goHome();
        });

        polygonSeries.mapPolygons.template.setAll({
            tooltipText: "{name}",
            // interactive: true,
            templateField: "polygonSettings",
        });

        // Create series for labels
        var pointSeries = chart.series.push(
            am5map.MapPointSeries.new(root, {
                polygonIdField: "polygonId"
            })
        );

        polygonSeries.mapPolygons.template.states.create("hover", {
            fill: am5.color(0x54A305)
        });

        // pointSeries.bullets.push(function() {
        //     return am5.Bullet.new(root, {
        //         sprite: am5.Label.new(root, {
        //             fontSize: 8,
        //             centerX: am5.p50,
        //             centerY: am5.p50,
        //             text: "{name}",
        //             populateText: true
        //         })
        //     });
        // });

        // Add state labels
        // polygonSeries.events.on("datavalidated", function(ev) {
        //     var series = ev.target;
        //     var labelData = [];
        //     series.mapPolygons.each(function(polygon) {
        //         labelData.push({
        //             polygonId: polygon.dataItem.get("id"),
        //             name: polygon.dataItem.get("name")
        //         })
        //     })
        //     pointSeries.data.setAll(labelData);
        // });


        polygonSeries.data.setAll([{
            id: "FR",
            name: "France",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "SQ",
            name: "Albania",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "SQ",
            name: "Albania",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "AT",
            name: "Austria",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "BE",
            name: "Belgium",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "BG",
            name: "Bulgaria",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "CZ",
            name: "Czech Republic",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "DE",
            name: "Germany",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "EE",
            name: "Estonia",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "FI",
            name: "Finland",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "FR",
            name: "France",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "GB",
            name: "Great Britain",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        },{
            id: "GR",
            name: "Greece",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        },{
            id: "HR",
            name: "Croatia",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "BA",
            name: "Bosnia and Herzegovina",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "HU",
            name: "Hungary",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "IL",
            name: "Israel",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "BA",
            name: "Bosnia and Herzegovina",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "IT",
            name: "Italy",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "JO",
            name: "Jordan",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "LT",
            name: "Lithuania",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "LU",
            name: "Luxembourg",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "LV",
            name: "Latvia",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "MD",
            name: "Moldova",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "MK",
            name: "North Macedonia",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "NL",
            name: "Netherlands",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "PL",
            name: "Poland",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "PS",
            name: "Palestine",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "PT",
            name: "Portugal",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "RO",
            name: "Romania",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "RS",
            name: "Serbia",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "ES",
            name: "Spain",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "SE",
            name: "Sweden",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "SI",
            name: "Slovenia",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "SK",
            name: "Slovakia",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "SM",
            name: "San Marino",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "UA",
            name: "Ukraine",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }, {
            id: "SK",
            name: "Kosovo",
            polygonSettings: {
                fill: am5.color(0x88E225)
            }
        }]);
    },

    trContactForm(){
        function validateEmail(elementValue1) {
            return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(elementValue1)
        }

        let validateNumbers = function (elementValue2) {
            return /^[-+]?[0-9]+$/.test(elementValue2);
        };

        $(document).on('submit', '.tradercars-contact-form', function (e) {
            e.preventDefault();
            let loader = $('.tradercars-contact-form .loader-holder');
            let checkMark = $('.tradercars-contact-form .form-checkbox');
            let errorMsg = $('.tradercars-contact-form .error-message');
            let successMsg = $('.tradercars-contact-form .success-message');
            errorMsg.hide();
            successMsg.hide();
            loader.show();
            let validation = true;
            let contactEmail = $('.tradercars-contact-form .form-email');
            let contactPhone = $('.tradercars-contact-form .form-phone');


            $(".form-input.req", this).each(function () {
                let element = $(this);
                if (element.val() === "") {
                    element.closest('.form-item').addClass('input-invalid');
                    validation = false;
                } else {
                    element.closest('.form-item').removeClass('input-invalid');
                }
            });

            if ($('.tradercars-contact-form .rules').is(":checked")) {
                checkMark.removeClass('input-invalid');
            } else {
                checkMark.addClass('input-invalid');
                validation = false;
            }

            let value = contactEmail.val();
            let valid = validateEmail(value);
            if (!valid) {
                contactEmail.closest('.form-item').addClass('input-invalid');
                validation = false;
            } else {
                contactEmail.closest('.form-item').removeClass('input-invalid');
            }

            let value2 = contactPhone.val();
            let valid2 = validateNumbers(value2);
            if (value2 !== "") {
                if (!valid2) {
                    contactPhone.closest('.form-item').addClass('input-invalid');
                    validation = false;
                } else {
                    contactPhone.closest('.form-item').removeClass('input-invalid');
                }
            }

            if (validation == true) {
                successMsg.slideDown(300);
            } else {
                errorMsg.slideDown(300);
            }

            setTimeout(function () {
                loader.fadeOut(300);
            }, 1000);
        });
    }
}